import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import { CONTENT_DISTRIBUTION_API } from '../constant/constant';

const ContentDistributionForm = (props) => {

    const {item, setItem , contentDistributionApis, AccessKey} = props;
    const lang = useTranslation();
    const [isCopying, setIsCopying] = useState(false);

    const handleCopyCurl = () => {
        setIsCopying(true);
        navigator.clipboard.writeText(item?.curlData || "");
        setTimeout(() => setIsCopying(false), 1000);
    };

    const generateCurlCommand = (baseUrl, distType) => {

        const url = typeof baseUrl === "string" ? baseUrl : baseUrl?.toString?.() ?? "";
        let body = {};

        if (distType === CONTENT_DISTRIBUTION_API.FULL_CATALOGUE) {
            body = {
                ResponseType: item?.ResponseType?._id,
                Page: 1,
                Size: 50,
            };
        } else if (distType === CONTENT_DISTRIBUTION_API.INCREMENTAL) {
            body = {
                ValidFrom: item?.ValidFrom,
                ValidTo: item?.ValidTo,
                Page: 1,
                Size: 50,
            };
        } else if (distType === CONTENT_DISTRIBUTION_API.DELIST) {
            body = {
                Archive: true,
                Page: 1,
                Size: 50,
            };
        }

        return `curl --location --request POST '${url}' \\
        --header 'Content-Type: application/json' \\
        --header 'x-access-token: Bearer ${AccessKey || "Please Generate Access Key"}' \\
        --data-raw '${JSON.stringify(body)}'`;
    };

    const dummyRes = `{
                    "success": true,
                    "data": {
                        "_id": "642d14eeaa72cdb6d0220a65",
                        "OttAssetTypeSID": 3,
                        "TBA": false,
                        "VideoPlaybackUrl": "https://vg-theqlive.akamaized.net/v1/master/611d79b11b77e2f571934fd80ca1413453772ac7/vglive-sk-565953/main.m3u8?ads.partner=qplayapp",
                        "routeType": 1,
                        "VodTypes": {
                            "_id": "647d7200eb2e4ebbbc646858",
                            "SID": 2,
                            "Name": "SVOD"
                        },
                        "Trailers": [
                            {
                                "_id": "64a40fc64159d87ef2e1b9c4",
                                "SID": 94471,
                                "Title": "The Fault in Our Star"
                            },
                            {
                                "_id": "650583948f754338be531851",
                                "SID": 97715,
                                "Title": "LA Confidential"
                            },
                            {
                                "_id": "650be55993b20cc366fbaf99",
                                "SID": 97741,
                                "Title": "Jawaan"
                            },
                            {
                                "_id": "65d33344f6901e67e4097ed3",
                                "SID": 99019,
                                "Title": "KAN MDM"
                            },
                            {
                                "_id": "6697558af72fc80f89418538",
                                "SID": 102767,
                                "Title": "The Fall Guy Trailer"
                            },
                            {
                                "_id": "66adffbe210560463664372f",
                                "SID": 103119,
                                "Title": "sample-1"
                            }
                        ],
                        "Title": "Janbazz Hindustan Ki PT 6",
                        "Description": "Janbazz Hindustan Ki PT 6",
                        "page_id": "",
                        "ReleaseDate": "",
                        "Duration": 0,
                        "Genres": [],
                        "MediaEpisodeDescription": "",
                        "CastAndCrew": [],
                        "Languages": [],
                        "PGRating": "N/A",
                        "Synopsis": "",
                        "Posters": [
                            {
                                "Description": "Potrait",
                                "OttPosterType": {
                                    "_id": "6343c44b601533b8ae90309f",
                                    "SID": 2,
                                    "Description": "Portrait",
                                    "Archive": false,
                                    "modBy": {
                                        "_id": "63411cc31b8a4456b4e663f4",
                                        "name": "Rajat"
                                    },
                                    "modOn": 1681227900067
                                },
                                "Url": "https://m.media-amazon.com/images/M/MV5BYTdhOTBiNTktYmRlMC00M2JiLTkxYWMtZjRiYTFjYzYyNGE3XkEyXkFqcGc@._V1_.jpg"
                            },
                            {
                                "Description": "Landscape",
                                "OttPosterType": {
                                    "_id": "6343c44b601533b8ae9030a0",
                                    "SID": 3,
                                    "Description": "Landscape",
                                    "Archive": false,
                                    "modBy": {
                                        "_id": "63411cc31b8a4456b4e663f4",
                                        "name": "Rajat"
                                    },
                                    "modOn": 1681227904197
                                },
                                "Url": "https://akamaividz2.zee5.com/image/upload/w_1755,h_987,c_scale,f_webp,q_auto:eco/resources/0-6-4z5281686/list/1170x658withlogo5588d0be152f484381bf4c42095c6019.jpg"
                            }
                        ],
                        "Videos": [
                            {
                                "Description": "HLS",
                                "OttVideoType": {
                                    "_id": "6481d7eceef22f0422fbd4b0",
                                    "SID": 2,
                                    "Description": "HLS",
                                    "Archive": false
                                },
                                "Url": "https://cdn.cast-tv.com/playout/3/playlist.m3u8",
                                "Platform": {
                                    "SID": 0,
                                    "Description": "All"
                                }
                            }
                        ],
                        "Season_id": "",
                        "Provider": {
                            "_id": "654b3eef1720797b7a62f8f1",
                            "SID": 1,
                            "Description": "Binging",
                            "LogoUrl": "https://www.zee5.com/images/ZEE5_logo.svg?ver=4.8.3",
                            "Archive": false,
                            "modBy": {
                                "_id": "637ca07c873dbe3accdc9cef",
                                "name": "Admin"
                            },
                            "modOn": 1723559904069,
                            "IsDefault": false
                        },
                        "Marker": [],
                        "playlistId": ""
                    },
                    "message": "Fetched Successfully"
                }`

    const onChange = (e) => {
        const { name, value } = e.target;

        let updatedItem = {...item, [name]: value};

        if (name === "ContentDistributionApi") {
            updatedItem.ContentDistributionApi = value; 
        }

        const baseUrl = name === "BaseUrl" ? value : updatedItem.BaseUrl;
        const distType = updatedItem?.ContentDistributionApi?._id;

        if (!baseUrl || !distType) {
            setItem({ ...updatedItem, curlData: "", response: "" });
            return;
        }

        const curl = generateCurlCommand(baseUrl, distType);
        setItem({ ...updatedItem, BaseUrl: baseUrl, curlData: curl, response: dummyRes });
    };

    return (
        <div className="p-3">
            <div className="row mb-3">
                <div className="col-4">
                    <label>{lang.content_distribution_api_label}</label>
                    <DropDownList
                        style={{ backgroundColor: "white" }}
                        className="form-control form-control-sm"
                        data={contentDistributionApis}
                        name="ContentDistributionApi"
                        textField="Description"
                        dataItemKey="_id"
                        onChange={onChange}
                        value={item?.ContentDistributionApi}
                    />
                </div>
                <div className="col-8">
                    <label>{lang.base_url_label}</label>
                    <input
                        type="text"
                        name="BaseUrl"
                        className="form-control form-control-sm"
                        value={item.BaseUrl}
                        onChange={onChange}
                        placeholder='Ex:- https://bmsuat.bossstudio.tv/v2/ott/getAssetById'
                    />
                </div>
            </div>
            <div className="mb-3">
                <h6>cURL</h6>
                <div style={{ position: 'relative', backgroundColor: '#1e1e1e', borderRadius: '5px', overflow: 'hidden', maxHeight: '180px' }}>
                    <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}>
                        {isCopying ? (
                            <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #dee2e6' }} title="Copied!">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4caf50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M9 12l2 2l4-4" />
                                </svg>
                            </div>
                        ) : (
                            <button
                                type="button"
                                onClick={handleCopyCurl}
                                style={{ padding: '4px', border: '1px solid #dee2e6', backgroundColor: '#ffffff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', borderRadius: '4px' }}
                                title="Copy to cURL"
                            >
                                <img src="https://cdn-icons-png.flaticon.com/512/60/60990.png" alt="copy" width="16" height="16" />
                            </button>
                        )}
                    </div>
                    <Form.Control
                        as="textarea"
                        rows={6}
                        value={item?.curlData}
                        readOnly
                        style={{ fontFamily: 'monospace', fontSize: '0.9rem', border: '1px solid grey', borderRadius: '0 0 5px 5px', padding: '1rem', paddingTop: '0.5rem', overflow: 'auto' }}
                    />
                </div>
                {!AccessKey && (
                    <p className="text-danger">
                        Please generate an access key before using cURL
                    </p>
                )}
            </div>
            <div>
                <h6>Response</h6>
                <div style={{ backgroundColor: "#f9f9f9", padding: "1rem", border: "1px solid #ccc", borderRadius: "5px", minHeight: "150px", maxHeight: "200px", overflowY: "auto" }}>
                    {item?.response ?
                        <pre style={{ fontSize: "0.9rem" }}>
                            {(() => {
                                try {
                                    return JSON.stringify(JSON.parse(item.response), null, 2);
                                } catch {
                                    return "Invalid JSON";
                                }
                            })()}
                        </pre>
                        :
                        <pre className="text-muted">
                            {JSON.stringify(JSON.parse(dummyRes), null, 2)}
                        </pre>
                    }
                </div>
            </div>
        </div>
    );
};

export default ContentDistributionForm;

